module.exports = __webpack_public_path__ + "static/media/search.aefab0fb.png";